




















import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";
import Logo from "@/shared/components/Logo.vue";
import PartnerFooter from "@/shared/components/PartnerFooter.vue";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    Logo,
    PartnerFooter
  }
})
export default class LoginWrapper extends Vue {
  @Prop({ default: true }) showBottomGraphic: boolean;
  @Prop({ default: true }) showFooter: boolean;

  userStore = useUserStore();

  get backgroundImageUrl (): string {
    return this.userStore.isEmployeePortal ? "." : "";
  }
}
